import $ from 'jquery';

(function () {

	if (!$('.products-overview-menu, .product-categories').length) {
		return;
	}

	const $trigger = $('.products-overview-menu__title, .product-categories__title, .product-filters__title');

	//only add dropdown function on small/medium screens
	if (Foundation.MediaQuery.is('large up')) {
		return;
	}

	$trigger.on('click', function (e) {
		e.preventDefault();
		$(this).parent().toggleClass('active');
	});
})();


